<div class="detail">
  <div class="pinner-bkg" *ngIf="isLoading">
    <div class="pinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="side" *ngIf="!isLoading">
    <request-detail-sidebar
            [request]="request"
            [users]="users"
            [fixedFollowers]="requestGroup?.followers"
            (removeFollower)="onRemoveFollower($event)"
            (addFollower)="onAddFollower($event)"></request-detail-sidebar>
  </div>
  <div class="main" *ngIf="!isLoading">
    <mat-card class="request-data">
      <mat-card-header class="request-header">
        <mat-card-title>{{request.name}}</mat-card-title>
        <mat-card-subtitle>
          <span class="target-date">Thời hạn xử lý: <span>{{dueDate}}</span></span>
          <span class="remain-time">Thời gian còn lại: <span>{{remainingTime}}</span></span>
        </mat-card-subtitle>
        <mat-card-actions class="request-header-actions">
          <button *ngIf="isOwner" mat-raised-button color="warn" (click)="deteleRequest()">Xóa</button>
          <button mat-icon-button [matMenuTriggerFor]="requestMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card-header>
      <div class="request-status">
        <span class="request-status-text">Trạng thái: </span> <span class="status">{{request.friendlyStatusName}}</span>
      </div>
      <div class="request-decision-actions" *ngIf="showDecisionActions">
        <button mat-raised-button color="primary" (click)="updateStatus('APPROVED', false)">Chấp Nhận</button>
        <button mat-raised-button (click)="updateStatus('APPROVED', true)">Chuyển Tiếp</button>
        <button mat-raised-button color="warn" (click)="updateStatus('REJECTED', false)">Từ Chối</button>
      </div>
      <div class="my-approvals cta" *ngIf="myApproval">
        <div class="msg" [class]="myApproval.status">
          <span class="icon">
            <mat-icon class="mati">{{myApproval.icon}}</mat-icon>
          </span> {{myApproval.text}}
        </div>
      </div>
      <mat-card-content>
        <div class="request-info">
          <mat-card class="request-info-card">
            <mat-card-header class="header-border-bottom">
              <mat-card-title>THÔNG TIN ĐỀ XUẤT
                <div class="request-code">Mã đề xuất: <span>{{request.id}}</span></div>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item>
                  <mat-icon mat-list-icon>person</mat-icon>
                  <div class="fieldName">Người tạo</div>
                  <div>
                    <span class="name">{{request.submitterUser.fullname}}</span>&nbsp;<span
                      class="name">@{{request.submitterUser.username}}</span>&nbsp;<span>({{request.submitterUser.title}})</span>
                  </div>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon mat-list-icon>inventory</mat-icon>
                  <div class="fieldName">Nhóm đề xuất</div>
                  <div class="groupName" [routerLink]="['/requests']" [queryParams]="{groupId: requestGroup.id}">
                    {{request.requestGroupName}}
                  </div>
                  <div class="approvalName">({{requestGroup.approvalTypeName}})</div>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon mat-list-icon>date_range</mat-icon>
                  <div class="fieldName">Thời gian tạo</div>
                  <div>{{request.submitTime | date:'HH:mm MMM d, y'}}</div>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon mat-list-icon>schedule</mat-icon>
                  <div class="fieldName">Cập nhật gần nhất</div>
                  <div>{{request.submitTime | date}}</div>
                </mat-list-item>
                <mat-list-item *ngIf="request.ogId">
                  <mat-icon mat-list-icon>arrow_right_alt</mat-icon>
                  <div class="fieldName">Chuyển tiếp từ</div>
                  <div class="groupName">{{request.ogName}}</div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="request-attrs">
          <mat-card class="request-attrs-card">
            <mat-card-header class="header-border-bottom">
              <mat-card-title>THÔNG TIN KHÁC (MẪU ĐĂNG KÝ ĐỀ XUẤT)</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <attribute-template [request]="request"></attribute-template>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="request-files">
          <mat-card class="request-file-card">
            <mat-card-header class="header-border-bottom">
              <mat-card-title>FILE ĐÍNH KÈM</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="no-file" *ngIf="attachments.length == 0">Không có file đính kèm</div>
              <mat-list class="files" *ngIf="attachments.length != 0">
                <mat-list-item class="file m-2" *ngFor="let file of attachments" (click)="onDownload(file)">
                  {{file.fileName}} (Tải về)
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="request-tasks">
          <mat-card class="request-task-card">
            <mat-card-header class="header-border-bottom">
              <mat-card-title>CÔNG VIỆC</mat-card-title>
              <div class="one-spacer"></div>
              <span class="add-task" (click)="onAddTask()"> + Thêm công việc</span>
            </mat-card-header>
            <mat-card-content>
              <div class="no-task" *ngIf="workPackages.length == 0">Không có công việc</div>
              <mat-list class="tasks" *ngIf="workPackages.length != 0">
                <mat-list-item class="task m-2" *ngFor="let wp of workPackages">
                  <span class="wp-status badge"
                  [ngClass]="wp.status.id == 1 ? 'badge-info' : wp.status.id == 7 ? 'badge-primary' : 'badge-success'">
                  {{wp.friendlyStatus}}</span>
                  <a href="{{wp.href}}" target="_blank" class="name flex-grow-1">{{wp.subject}}</a>
                  <div class="assignee" *ngIf="wp.assignee">
                    <div class="d-flex user-info">
                      <div class="m-1 avatar">
                          <one-avatar size="28" [imageUrl]="wp.assignee.avatarUrl"></one-avatar>
                      </div>
                      <div class="m-2 info  flex-grow-1">
                          <div class="name">
                              {{wp.assignee.fullName}}
                          </div>
                      </div>
                  </div>
                  </div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="request-discussions">
          <mat-card class="request-discussion-card">
            <mat-card-header class="header-border-bottom">
              <mat-card-title>THẢO LUẬN</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <discussions [request]="request" [users]="users"></discussions>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="space-20"></div>
    <div class="space-20"></div>
    <div class="space-20"></div>
  </div>

</div>
<mat-menu #requestMenu="matMenu">
  <button mat-menu-item (click)="onPrint()">
    <mat-icon>print</mat-icon>
    <span class="title">In đề xuất</span>
  </button>
  <button mat-menu-item *ngIf="canEdit" (click)="onEdit()">
    <mat-icon>edit</mat-icon>
    <span class="title">Chỉnh sửa đề xuất</span>
  </button>
  <button mat-menu-item (click)="onClone()">
    <mat-icon>filter_none</mat-icon>
    <span class="title">Nhân bản đề xuất</span>
  </button>
  <button mat-menu-item (click)="onForward()">
    <mat-icon>forward</mat-icon>
    <span class="title">Chuyển tiếp đề xuất</span>
  </button>
  <button mat-menu-item *ngIf="canEdit" (click)="onCancel()">
    <mat-icon>delete_outline</mat-icon>
    <span class="title">Hủy đề xuất</span>
  </button>
</mat-menu>
